import React from 'react';
import './AboutStory.css';

const CHAPTERS = [
  {
    year: '2019',
    tag: 'THE BEGINNING',
    title: 'A KID FROM KOKSTAD.',
    body: `It started the way most great things do — with obsession. Growing up in Kokstad, sneakers were never just shoes. They were status, identity, and culture all wrapped in a box. By 16, every cent of pocket money went towards the next pair. By 18, those pairs were being flipped to fund the next ones. Then came the move to Durban — and everything changed.`,
    img: 'https://images.unsplash.com/photo-1514989940723-e8e51635b782?w=700&q=85',
  },
  {
    year: '2021',
    tag: 'THE HUSTLE',
    title: 'SELLING FROM THE BEDROOM.',
    body: `What started as selling a few personal pairs to friends turned into something nobody expected. Word spread fast. People wanted heat but had nowhere to get it locally without paying reseller markups that made no sense. A bedroom operation became a WhatsApp group. The WhatsApp group became a waiting list. SA Dropped was no longer just a hobby.`,
    img: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=700&q=85',
  },
  {
    year: '2023',
    tag: 'THE BRAND',
    title: 'SA DROPPED IS BORN.',
    body: `The name came naturally. Every time a new pair landed — the group went mad. SA Dropped. It captured exactly what we were about. We built the website, locked in supplier relationships, and made it official. Durban to your door. Verified kicks, no nonsense, straight to the people who actually love the culture.`,
    img: 'https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?w=700&q=85',
  },
  {
    year: '2025',
    tag: 'THE MOVEMENT',
    title: 'BIGGER THAN SHOES.',
    body: `SA Dropped is no longer just a store. It's a community of people who understand that the right pair changes how you move through the world. We ship nationwide, stock 40 plus brands, and every single pair is verified before it reaches your door. This is only the beginning.`,
    img: 'https://images.unsplash.com/photo-1491553895911-0055eca6402d?w=700&q=85',
  },
];

export default function AboutStory() {
  return (
    <section className="ast">
      <div className="ast__container">
        <div className="ast__intro">
          <p className="ast__eyebrow">T h e &nbsp; J o u r n e y</p>
          <h2 className="ast__main-title">STREETS TO STUDIO</h2>
        </div>

        <div className="ast__grid">
          {CHAPTERS.map((ch, i) => (
            <div key={i} className={`ast__row ${i % 2 !== 0 ? 'ast__row--alt' : ''}`}>
              <div className="ast__visual">
                <div className="ast__img-wrap">
                  <img src={ch.img} alt={ch.title} />
                  <span className="ast__big-year">{ch.year}</span>
                </div>
              </div>
              
              <div className="ast__text">
                <span className="ast__tag">{ch.tag}</span>
                <h3 className="ast__ch-title">{ch.title}</h3>
                <p className="ast__body-text">{ch.body}</p>
                <div className="ast__accent-line"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="ast__footer">
          <p className="ast__location-tag">OPERATING OUT OF DURBAN, KZN — SHIPPING NATIONWIDE</p>
        </div>
      </div>
    </section>
  );
}